import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { ChildTechnologyPreference, CompanyUser, Job, ParentTechnologyPreference, StatusConstant } from 'src/app/constants/message-constant';
import { CommonService } from 'src/app/services/common/common.service';
import { College } from '../../constants/message-constant';
import { CollegeBatch } from 'src/app/constants/message-constant';
import { StudentConstant } from 'src/app/constants/message-constant';
import { QuestionSet } from 'src/app/constants/message-constant';
import { QuestionStatus } from 'src/app/constants/message-constant';
import { User } from 'src/app/constants/message-constant';
import { Company } from 'src/app/constants/message-constant';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-status-dialogbox',
  templateUrl: './status-dialogbox.component.html',
  styleUrls: ['./status-dialogbox.component.scss']
})
export class StatusDialogboxComponent {
  constructor(
    public modalService: NgbActiveModal,
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
  ) { }

  element: string = '';
  Name: string = '';
  active: boolean = false;
  statusConstant: any = [];
  userId: number = 0;
  firstName: string = '';
  collegeStatusObj: any = {};
  collegeBatchStatusObj: any = {};
  parentTechnologyPreferenceStatusObj: any = {};
  childTechnologyPreferenceStatusObj: any = {};
  studentStatusObj: any = {};
  questionSetStutusObj: any = {};
  questionStatusObj: any = {};
  userStatusObj: any = {};
  companyStatusObj: any = {};
  companyUserStatusObj: any = {};
  jobStatusObj: any = {};
  ApiURL: string = '';
  inActiveNotification: string = '';
  activeNotification: string = ''

  ngOnInit(): void {
    this.statusConstant = StatusConstant;
    if (this.collegeStatusObj.collegeId > 0) {
      this.Name = this.collegeStatusObj.collegename;
      this.active = this.collegeStatusObj.activecollege;
    }
    else if (this.collegeBatchStatusObj.collegeBatchId > 0) {
      this.Name = this.collegeBatchStatusObj.collegeBatchname;
      this.active = this.collegeBatchStatusObj.activeBatch;
    }
    else if (this.parentTechnologyPreferenceStatusObj.ParentTechnologyPreferenceId > 0) {
      this.Name = this.parentTechnologyPreferenceStatusObj.ParentTechnologyPreferenceName;
      this.active = this.parentTechnologyPreferenceStatusObj.activeTechnology;
    }
    else if (this.childTechnologyPreferenceStatusObj.ChildTechnologyPreferenceId > 0) {
      this.Name = this.childTechnologyPreferenceStatusObj.ChildTechnologyPreferenceName;
      this.active = this.childTechnologyPreferenceStatusObj.activeTechnology;
    }
    else if (this.studentStatusObj.studentId > 0) {
      this.Name = this.studentStatusObj.studentName;
      this.active = this.studentStatusObj.activeStudent;
    }
    else if (this.questionSetStutusObj.questionSetId > 0) {
      this.Name = this.questionSetStutusObj.questionSetName;
      this.active = this.questionSetStutusObj.activequestionSet;
    }
    else if (this.questionStatusObj.questionId > 0) {
      this.Name = this.questionStatusObj.questionText;
      this.active = this.questionStatusObj.activeQuestion;
    }
    else if (this.userStatusObj.userId > 0) {
      this.Name = this.userStatusObj.userName;
      this.active = this.userStatusObj.activeUser;
    }
    else if (this.companyStatusObj.companyId > 0) {
      this.Name = this.companyStatusObj.companyName;
      this.active = this.companyStatusObj.activecompany;
    }
    else if (this.companyUserStatusObj.userId > 0) {
      this.Name = this.companyUserStatusObj.userName;
      this.active = this.companyUserStatusObj.activeUser;
    }
    else if (this.jobStatusObj.jobid > 0) {
      this.Name = this.jobStatusObj.jobname;
      this.active = this.jobStatusObj.activejob;
    }
  }
  Onstatus() {
    if (this.collegeStatusObj.collegeId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.college.InActiveCollege.replace('{id}', this.collegeStatusObj.collegeId.toString());
      this.inActiveNotification = College.INACTIVE;
      this.activeNotification = College.ACTIVE;
    }
    else if (this.collegeBatchStatusObj.collegeBatchId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.collageBatch.ActiveCollegeBatch.replace('{id}', this.collegeBatchStatusObj.collegeBatchId.toString());
      this.inActiveNotification = CollegeBatch.INACTIVE;
      this.activeNotification = CollegeBatch.ACTIVE;
    }
    else if (this.parentTechnologyPreferenceStatusObj.ParentTechnologyPreferenceId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.ParentTechnologyPreferences.ActiveParentTechnologyPreference.replace('{id}', this.parentTechnologyPreferenceStatusObj.ParentTechnologyPreferenceId.toString());
      this.inActiveNotification = ParentTechnologyPreference.INACTIVE;
      this.activeNotification = ParentTechnologyPreference.ACTIVE;
    }
    else if (this.childTechnologyPreferenceStatusObj.ChildTechnologyPreferenceId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.ChildTechnologyPreferences.ActiveChildTechnologyPreference.replace('{id}', this.childTechnologyPreferenceStatusObj.ChildTechnologyPreferenceId.toString());
      this.inActiveNotification = ChildTechnologyPreference.INACTIVE;
      this.activeNotification = ChildTechnologyPreference.ACTIVE;
    }
    else if (this.studentStatusObj.studentId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.student.ActiveInactive.replace('{id}', this.studentStatusObj.studentId.toString());
      this.inActiveNotification = StudentConstant.INACTIVE;
      this.activeNotification = StudentConstant.ACTIVE;
    }
    else if (this.questionSetStutusObj.questionSetId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.QuestionSet.ActiveQuestionSet.replace('{id}', this.questionSetStutusObj.questionSetId.toString());
      this.inActiveNotification = QuestionSet.INACTIVE;
      this.activeNotification = QuestionSet.ACTIVE;
    }
    else if (this.questionStatusObj.questionId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.question.InActiveQuestion.replace('{id}', this.questionStatusObj.questionId.toString());
      this.inActiveNotification = QuestionStatus.INACTIVE;
      this.activeNotification = QuestionStatus.ACTIVE;
    }
    else if (this.userStatusObj.userId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.user.ActiveUser.replace('{id}', this.userStatusObj.userId.toString());
      this.inActiveNotification = User.INACTIVE;
      this.activeNotification = User.ACTIVE;
    }
    else if (this.companyStatusObj.companyId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.company.ActiveCompany.replace('{id}', this.companyStatusObj.companyId.toString());
      this.inActiveNotification = Company.INACTIVE;
      this.activeNotification = Company.ACTIVE;
    }
    else if (this.companyUserStatusObj.userId > 0) {
      this.ApiURL = this.apiUrl.apiUrl.companyUser.ActiveCompanyUser.replace('{id}', this.companyUserStatusObj.userId.toString());
      this.inActiveNotification = CompanyUser.INACTIVE;
      this.activeNotification = CompanyUser.ACTIVE;
    }
    else if (this.jobStatusObj.jobid > 0) {
      this.ApiURL = this.apiUrl.apiUrl.job.ActiveJob.replace('{id}', this.jobStatusObj.jobid.toString());
      this.inActiveNotification = Job.INACTIVE;
      this.activeNotification = Job.ACTIVE;
    }
    this.spinner.show();
    this.commonService.doPut(this.ApiURL, '').pipe().subscribe({
      next: (data) => {
        if (data.success) {
          if (this.active == true) {
            this.toastr.success(data.message);
          }
          else {
            this.toastr.success(data.message);
          }
          this.modalService.close('status');
          this.spinner.hide();
        }
        else {
          this.toastr.error(data.message);
        }
      },
      error: (er) => {
        console.error(er)
      }
    });
  }
}